import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import SelectOrCreateFileInput from 'files/components/SelectOrCreateFileInput';
import SearchInput from 'search/inputs/SearchInput';
import {Filter} from 'search/SearchConstants';

interface SearchEditorProps {
  config: string | null;
  onChangeConfig: (config: string | null) => void;
  modelTypes: Array<ModelTypeConstants>;
  schemaIds?: Array<string> | null;
  schemaInterfaceIds?: Array<string> | null;
  additionalFilters?: Array<Filter>;
  disabled?: boolean;
}

// The search index stores installed apps as `benchling_app`, so search for that instead of the
// `app_installation` domain type.
const SEARCH_TYPE_OVERRIDES: Partial<Record<ModelTypeConstants, ModelTypeConstants>> = {
  [ModelTypeConstants.APP_INSTALLATION]: ModelTypeConstants.BENCHLING_APP,
  [ModelTypeConstants.LEGACY_APP_INSTALLATION]: ModelTypeConstants.BENCHLING_APP,
};

export function getSearchTypes(modelTypes: Array<ModelTypeConstants>): Array<ModelTypeConstants> {
  return [...new Set(modelTypes.map((modelType) => SEARCH_TYPE_OVERRIDES[modelType] ?? modelType))];
}

export default function SearchEditor({
  config,
  onChangeConfig,
  disabled,
  modelTypes,
  schemaIds,
  schemaInterfaceIds,
  additionalFilters,
}: SearchEditorProps): JSX.Element {
  if (modelTypes.length > 0 && modelTypes.every((modelType) => modelType === ModelTypeConstants.FILE)) {
    return (
      <SelectOrCreateFileInput
        disabled={disabled}
        maxItems={1}
        onRemove={() => {
          onChangeConfig(null);
        }}
        onSelect={(itemId) => {
          onChangeConfig(itemId.length > 0 ? itemId[0] : null);
        }}
        placeholder=""
        selected={config == null ? [] : [config]}
      />
    );
  } else {
    return (
      <SearchInput
        autoFocus={false}
        disabled={disabled}
        disableTyping={config != null}
        isMulti={false}
        onRemove={() => {
          onChangeConfig(null);
        }}
        onSelect={(itemId) => {
          onChangeConfig(itemId);
        }}
        placeholder=""
        additionalFilters={additionalFilters}
        schemaIds={schemaIds ?? undefined}
        schemaInterfaceIds={schemaInterfaceIds ?? undefined}
        selected={config == null ? [] : [config]}
        types={getSearchTypes(modelTypes)}
      />
    );
  }
}
